import { useTranslation } from 'react-i18next'
import {
  CreateView,
  CreateViewHeader,
} from '~/components/refineUi/views/createView'
import { CabinetForm } from './form'

export function CabinetCreate() {
  const { t } = useTranslation()
  return (
    <CreateView>
      <CreateViewHeader title={t('cabinetsPage.create.title')} />
      <CabinetForm action="create" />
    </CreateView>
  )
}
